import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "blog-post-component flex gap flex-responsive" }
const _hoisted_2 = { class: "image-container flex-1 flex-vh-center text-center" }
const _hoisted_3 = { class: "content-container flex-2" }
const _hoisted_4 = { class: "flex gap-small" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Read Full Post")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileIcon = _resolveComponent("FileIcon")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FileIcon, {
        width: 48,
        height: 48
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.blogPost.title), 1),
      _createElementVNode("small", null, _toDisplayString(_ctx.displayPostedAt) + " (" + _toDisplayString(_ctx.displayPostedAtDifference) + ")", 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.blogPost.summary), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: _ctx.url }, {
            default: _withCtx(() => [
              _createVNode(_component_ButtonComponent, null, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}